import { NEXT_PUBLIC_YEAR_FOR_REPLACEMENT } from '@monoimin/constants';

export const getYearForReplacement = () => {
  return (
    NEXT_PUBLIC_YEAR_FOR_REPLACEMENT || new Date().getFullYear().toString()
  );
};
